import "./Footer.css";

const Footer = () => {
  return (
    <div >{new Date().getFullYear()} {" "}
     
    </div>
  )
}
export default Footer